module.exports = __webpack_public_path__ + "img/huanhuo6_pc.9938901.jpg";